import React from 'react';
import { MenuItem, IconButton, Drawer} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import { Link } from "react-router-dom";

export default function FadeMenu() {
  const [drawerState,setDrawerState] = React.useState(false);
  const toggleDrawer = (event) => {
    setDrawerState(!drawerState);
  }

  return (
    <div>
      <IconButton edge="start" color="inherit" onClick={toggleDrawer} >
        <MenuIcon />
      </IconButton>
      <Drawer anchor="left" open={drawerState} onClose={toggleDrawer}>
        <MenuItem><Link to="/" onClick={toggleDrawer}>Home</Link></MenuItem>
        <MenuItem><Link to="/Tournaments" onClick={toggleDrawer}>Tournaments</Link></MenuItem>
        <MenuItem><Link to="/Chart" onClick={toggleDrawer}>Chart View</Link></MenuItem>
        <MenuItem><Link to="/CardList" onClick={toggleDrawer}>Cards View</Link></MenuItem>
      </Drawer>
    </div>
  );
}
